export default "__VITE_ASSET__CMZwly4V__"